<template>
  <div class="pay_order">
    <van-sticky>
      <van-nav-bar title="提现明细" left-arrow @click-left="goback()" />
    </van-sticky>
    <div class="order_number">累计提成： + {{detail.totalCash}}元</div>
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad" :immediate-check="false">
        <van-tabs :v-modelActive="active" title-active-color="#FCA33D" color="#FCA33D" @click="onClickTabs">
          <van-tab v-for="(items, indexs) in title" :key="indexs" :title="items">
            <div class="order_list" v-for="(item, index) in applyList" :key="index">
              <div class=" list_top">
                <div class="flex_column ">
                  <div>提现方式：{{item.paymentMethod_name}}</div>
                  <div class="fs11 color999 m-t10">{{item.createtime}}</div>
                </div>
                <div class="flex_column ai_center ">
                  <div>+ <span class="fs15">{{item.actualAmount}}</span></div>
                  <div class="fs11 m-t5" style="color:#43AE45">{{item.status_name}}</div>
                </div>
              </div>
              <van-grid :column-num="3">
                <van-grid-item>
                  <div class="order_grid">
                    <div>申请提成</div>
                    <span>{{item.amount}}</span>
                  </div>
                </van-grid-item>
                <van-grid-item>
                  <div class="order_grid">
                    <div>实际金额</div>
                    <span>{{item.actualAmount}}</span>
                  </div>
                </van-grid-item>
                <van-grid-item>
                  <div class="order_grid">
                    <div>提现手续费</div>
                    <span>{{item.platformFee}}</span>
                  </div>
                </van-grid-item>
              </van-grid>
              <!-- <div class="loock_order_detail">查看提现详情</div> -->
            </div>
          </van-tab>
        </van-tabs>
      </van-list>
    </van-pull-refresh>
  </div>
</template>
<script>
import { Button, NavBar, Icon, Sticky, Tab, Tabs, Grid, GridItem, Toast, PullRefresh, List, Notify} from "vant";
export default {
  components: {
    [Button.name]: Button,
    [Icon.name]: Icon,
    [NavBar.name]: NavBar,
    [Sticky.name]: Sticky,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
    [PullRefresh.name]: PullRefresh,
    [List.name]: List,
  },
  data() {
    return {
      detail: {
        "totalCash": 0,
        "canCash": 0,
        "appliedCash": 0,
        "waitCash": 0,
        "rejectCash": 0,
        "alreadyCash": 0
      },
      loading: false, //底部加载状态
      finished: false, //底部是否完成状态
      isLoading: false,
      active: 0,
      userInfo: "",
      title: ["所有", "待审核", "待付款", "已打款", "无效"],
      page: 1,
      size: 20,
      applyList: [],
      total:0,
    };
  },
  mounted() {
    this.getCashInfo()
    this.getUserInfo()
    this.getApplyList()
  },
  methods: {
    //返回上一页
    goback() {
      if (window.history.length <= 1) {
        this.$router.push({ path: "/" });
        return false;
      } else {
        this.$router.go(-1);
      }
    },

    //跳转立即租赁
    toSiteLease() {
      this.$router.push({ path: "/home/siteLease" });
    },

    //跳转立即预约
    toSiteSubscribe() {
      this.$router.push({ path: "/home/siteSubscribe" });
    },

    //获取分销佣金
    getCashInfo() {
      let that = this;
      that.$api.userH5ApplyCashAPI("").then(function(res) {
        if (res.data.code == 200) {
          that.detail = res.data.data
        } else {
          Notify({ type: "danger", message: '接口返回异常：' + res.data.message });
        }
      }).catch(function(err) {
        Notify({ type: "danger", message: JSON.stringify(err) });
      })
    },

    //获取分销用户信息
    getUserInfo() {
      let that = this;
      that.$api.distributorIndexAPI("").then(function(res) {
        if (res.data.code == 200) {
          that.userInfo = res.data.data
        } else {
          Notify({ type: "danger", message: '接口返回异常：' + res.data.message });
        }
      }).catch(function(err) {
        Notify({ type: "danger", message: JSON.stringify(err) });
      })
    },

    //获取提现列表
    getApplyList(isLoadMore = false) {
      let that = this;
      that.$api.userH5ApplyListAPI({
        status: that.active == 0?"":that.active,
        page: that.page,
        size: that.size,
      }).then(function(res) {
        if (res.data.code == 200) {
          if (that.page > 1) {
            that.applyList = (!isLoadMore && res.data.dataList.length != 0) ? res.data.dataList : that.applyList;
            that.applyList = (isLoadMore && res.data.dataList.length != 0) ? that.applyList.contact(res.data.dataList) : that.applyList
          } else {
            that.applyList = res.data.dataList
          }
          that.total = res.data.total
          if(res.data.dataList.length == 0 && that.page > 1)
          that.finished = true
        } else {
          Notify({ type: "danger", message: '接口返回异常：' + res.data.message });
        }
      }).catch(function(err) {
        Notify({ type: "danger", message: JSON.stringify(err) });
      })
    },

    //切换订单状态
    onClickTabs(e) {
      //console.log('订单状态：'+e)
      this.active = e
      this.getApplyList()
    },

    //下拉刷新
    onRefresh() {
      let that = this
      that.page = 1;
      setTimeout(() => {
        that.isLoading = false
        that.getApplyList()
      }, 1000);
    },

    //上拉加载
    onLoad() {
      let that = this;
      that.page = that.page + 1
      setTimeout(() => {
        that.getApplyList(true);
      }, 1000);
    },
  }
};

</script>
<style lang="less" scoped>
.pay_order {
  .order_number {
    background: #fca33d;
    padding: 15px;
    font-size: 14px;
    color: #fff;
  }

  .order_list {
    border-top: 10px solid #f3f3f1;
    font-size: 14px;

    .list_top {
      padding: 10px;
      display: flex;
      justify-content: space-between;
    }
  }

  .order_grid {
    display: flex;
    align-items: center;
    flex-direction: column;
    font-size: 12px;

    span {
      font-size: 12px;
      color: #999;
      margin-top: 5px;
    }
  }

  .loock_order_detail {
    font-size: 13px;
    color: #666;
    text-align: center;
    background: #e9e9e7;
    padding: 15px;
  }
}

</style>



// WEBPACK FOOTER //
// src/views/layout/distribution/withdrawDetail.vue